import type { GalleryProductBase } from '@/components/ProductCard/types'
import { useTranslation } from 'react-i18next'
import { FlagRenderer } from '@/components/FlagRenderer/FlagRenderer'

export function ProductDesign({
  designCenter,
  countryCode,
  designation,
  className = 'product-design',
  labelClassName = 'product-card-manufacture-labels',
  designationClassName = 'product-card-manufacture-cz-label',
}: Readonly<{
  designCenter?: GalleryProductBase['design_center']
  countryCode?: string
  designation?: string
  className?: string
  labelClassName?: string
  designationClassName?: string
}>) {
  const { t } = useTranslation()

  return (
    <div className={className}>
      <span className={labelClassName}>
        {t('products-page.product-card.design-from')}
      </span>
      {!designCenter
        ? t('products-page.product-card.no-data')
        : countryCode && (
          <FlagRenderer
            key={designCenter.id}
            countryCode={countryCode}
            ariaHidden={Boolean(designation)}
          />
        )}
      {designation && (
        <span className={designationClassName}>{designation.replace(/^CZ\s+/, '')}</span>
      )}
    </div>
  )
}
